import { CreateElement, FunctionalComponentOptions, RenderContext } from 'vue';
import { Store } from 'vuex';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { RootStoreState } from '../../../store';
import Facet from './facet.vue';

export default {
  functional: true,
  render(createElement: CreateElement, { props }: RenderContext) {
    const store = container.get<Store<RootStoreState>>(DEPENDENCIES.Store);
    const facets = Object.keys(store.state.search.facetsGroups[props.groupId].facets);
    return facets.map(facetName =>
      createElement(Facet, {
        props: {
          facetName,
          groupId: props.groupId,
          key: `facet-${ facetName }`
        }
      }));
  }
} as FunctionalComponentOptions;
